/**
 * Server side document access management logic is now at ServerAccessManager due to
 * issue https://mantis.formbird.com/view.php?id=12225.
 */
import { isString, trim, isObject, isArray } from 'lodash';
import { SharedConstants } from '@formbird/types';
export class AccessManager {
    static filterNullKeyIds(keyId) {
        return isString(keyId) && trim(keyId) && keyId !== 'undefined';
    }
    static filterObjectOnlyAccessKeys(accessKey) {
        return isObject(accessKey);
    }
    static getUserAccessKeysForOperation(userAccountControlDocument, operation) {
        const userAccessKeysForOperation = [];
        // See issue 12125 for more info about Account Control Documents
        let userAccessKeys = userAccountControlDocument ? userAccountControlDocument.accessKeys : null;
        if (userAccessKeys) {
            userAccessKeys = userAccessKeys.filter(AccessManager.filterObjectOnlyAccessKeys);
            for (let x = 0; x < userAccessKeys.length; x++) {
                const userAccessKey = userAccessKeys[x];
                const key = userAccessKey.keyId ? userAccessKey.keyId : userAccessKey.documentId;
                if (key && userAccessKey.rights && userAccessKey.rights.indexOf(operation) > -1) {
                    userAccessKeysForOperation.push(key);
                }
            }
        }
        return userAccessKeysForOperation;
    }
    // Retains the old behavior of 'hasPermission'; Returns true if user is allowed to perform at least 1 operation.
    static checkPermission(targetDocument, userAccountControlDocument, operations, noTemplateAccessKeys) {
        const noTemplateAccessKeyIds = noTemplateAccessKeys ? noTemplateAccessKeys : [];
        let documentKeyIds = targetDocument && targetDocument.systemHeader
            && targetDocument.systemHeader.keyIds ? targetDocument.systemHeader.keyIds : noTemplateAccessKeyIds;
        documentKeyIds = documentKeyIds.filter(AccessManager.filterNullKeyIds);
        for (let j = 0; j < operations.length; j++) {
            const operation = operations[j];
            // Documents without keys are unrestricted during non-offline operations.
            if ((!documentKeyIds || documentKeyIds.length === 0) && operation !== SharedConstants.OPERATION_TYPE_OFFLINE) {
                return true;
            }
            const userAccessKeysForOperation = AccessManager.getUserAccessKeysForOperation(userAccountControlDocument, operation);
            for (let i = 0; i < userAccessKeysForOperation.length; i++) {
                if (documentKeyIds && documentKeyIds.indexOf(userAccessKeysForOperation[i]) > -1) {
                    return true;
                }
            }
        }
        return false;
    }
    static checkAccess(targetDocument, userAccountControlDocument, operation, noTemplateAccessKeys) {
        if (isArray(operation)) {
            return AccessManager.checkPermission(targetDocument, userAccountControlDocument, operation, noTemplateAccessKeys);
        }
        return AccessManager.checkPermission(targetDocument, userAccountControlDocument, [operation], noTemplateAccessKeys);
    }
    static writeKeysToDocument(document, template, userAccountControlDocument, defaultAttachKeys) {
        // Prepare systemHeader and keyIds
        document.systemHeader = document.systemHeader ? document.systemHeader : {};
        document.systemHeader.keyIds = document.systemHeader.keyIds ? document.systemHeader.keyIds : [];
        let attachKeys = [].concat(document.systemHeader.keyIds);
        if (template && template.attachKeys && template.attachKeys.length) {
            attachKeys = attachKeys.concat(template.attachKeys);
        }
        attachKeys = attachKeys.concat(userAccountControlDocument.attachKeys);
        if (defaultAttachKeys && defaultAttachKeys.length) {
            attachKeys = attachKeys.concat(defaultAttachKeys);
        }
        document.systemHeader.keyIds = Array.from(new Set(attachKeys));
        document.systemHeader.keyIds = document.systemHeader.keyIds.filter(AccessManager.filterNullKeyIds);
    }
    static hasPermission(targetDocument, userAccountControlDocument, operations) {
        const operationArr = operations.split(',');
        return AccessManager.checkPermission(targetDocument, userAccountControlDocument, operationArr);
    }
}
